import { render, staticRenderFns } from "./promotions_es.vue?vue&type=template&id=221b66f8&"
import script from "./promotions_es.vue?vue&type=script&lang=js&"
export * from "./promotions_es.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports